<!-- Cookie consent toast. Hardened for iOS Safari, where earlier versions showed
     the bar but rendered its text invisible. Two root causes are now removed at
     once:
       1. COLOUR: the surface + text colours are LITERAL hex per colour scheme
          (see .scss) with an explicit -webkit-text-fill-color, so the copy can
          never resolve to an invisible/transparent value the way the theme
          tokens could on iPad.
       2. COMPOSITING: the toast sits inside a full-viewport, non-interactive
          `.cookie-layer` that owns a stable GPU backing store (translateZ on the
          WRAPPER, never on the bar — putting it on the bar caused a separate
          scroll-vanish bug). iOS then keeps a backing store for the glyphs
          instead of evicting the lone fixed bar's text when other content
          composites. -->
<div *ngIf="!accepted && !stripped" class="cookie-layer" aria-hidden="false">
  <div class="cookie-popup" role="region" aria-label="Cookie notice">
    <span class="cookie-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M12 3a9 9 0 1 0 9 9 2 2 0 0 1-2-2 3 3 0 0 1-3-3 2 2 0 0 1-2-2 3 3 0 0 1-1-2z"
              stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
        <circle cx="9" cy="11" r="1.05" fill="currentColor"/>
        <circle cx="13.5" cy="14" r="1.05" fill="currentColor"/>
        <circle cx="9.5" cy="15.5" r="0.95" fill="currentColor"/>
      </svg>
    </span>

    <p class="cookie-message">
      We use cookies to give you a better experience. See our
      <a class="cookie-link" rel="noopener"
         routerLink="{{URLS.cookiePolicy}}" target="_blank">Cookie Policy</a>.
    </p>

    <div class="codigrate-button cookie-accept" role="button" tabindex="0"
         (click)="setAccepted()" (keyup.enter)="setAccepted()">
      <p>Got It</p>
    </div>
  </div>
</div>
